
export const Environment = {

    LIMITE_DE_LINHAS: 10,

    INPUT_DE_BUSCA: 'Pesquisar...',

    LISTAGEM_VAZIA: 'Nenhum registro encontrado.',

    URL_BASE: 'http://localhost:3333',

    // BACK_END_URL: 'http://192.168.3.194:5000/api',
    // BACK_END_URL: 'http://localhost:5000/api',
    //BACK_END_URL: 'https://hmlg.htisystem.com.br/api', //homologa
    // BACK_END_URL: 'http://localhost:3000/api'
     BACK_END_URL: 'https://htisystem.com.br/api/' //prod
};

export const ColorsLimite = {
    verde: '#5e8158',
    amarelo: '#aca53c',
    laranja: '#a14c13',
    vermelho: '#651313'
};

export const FilesType = {
    informacoes_gerais: [
        'Psb',
        'Estrutura Organizacional',
        'Licenças Ambientais, Outorgas E Demais Requerimentos Legais',
        'ART e Manifestação de Ciência',
        'Responsabilidade Técnica',
        'Direito Minerário',
        'Registros Fotográficos',
    ],
    documentacao_tecnica_do_empreendimento: [
        'Outros Projetos',
        'Projetos (básico e/ou executivo)',
        'Projeto como construído (as built)',
        'Revisão Periódica de Segurança de Barragens',
        'Projeto como está (as is)',
        'Análise de estabilidade geotécnica e hidráulica',
        'Peer review',
        'Relatório de gestão de riscos',
        'Relatório de gestão de mudanças',
        'Relatório de Inspeção de Segurança Regular',
        'Relatório de Inspeção de Segurança Especial',
        'Estudos ambientais',
        'Estudo de ruptura hipotética',
        'Relatório dos simulados de emergência',
        'Relatório de comunicação externa',
        'Plano de fechamento',
        'Apresentação do comitê de vigilância geotécnica',
        'Relatório do comitê de vigilância geotécnica',
        'Relatórios de auditorias externas',
        'Relatórios do IGTRB/IPR',
        'Relatório de lições aprendidas',
        'Relatório de auditoria anual',
        'Relatório de investigações geotécnicas',
        'Topografias',
        'Estudo tensão x deformação',
        'Croquis dos instrumentos',
        'Carta de risco',
        'Registros fotográficos',
        'Imagens satélites ou aéreas',
        'Caracterização dos rejeitos (ensaios e análises da NBR10004)',
        'Relatório de análise sísmica',
        'Plano de disposição de rejeitos',
        'Plano de comunicação',
        'Investigação de Campo',
        'Investigação Laboratorial',
    ],
    plano_de_acao_de_emergencia_pae: [
        'RCO',
        'Aoc',
        'Plano de Ação de Emergência',
        'Treinamento Interno Semestral',
        'Seminário Orientativo Anual',
        'Registro de Situação Emergência',
    ],
    planos_e_procedimentos: [
        'Plano de treinamento',
        'Plano de operação',
        'Cronograma de testes e calibrações',
        'Manuais dos equipamentos com cronogramas de testes e calibração',
        'Política de Saúde e segurança ocupacional, gestão geotécnica e sustentabilidade',
        'Padrão de gestão de estruturas geotécnicas',
        'Plano de capacitação dos profissionais',
        'Procedimento de gestão de risco',
        'Procedimento de controle de documentos',
        'Legislação vigente',
        'Procedimento de gestão de mudanças',
        'Plano de gestão da qualidade',
        'Plano de ação da inspeção',
    ],
    registros_e_controles: [
        'Relação dos recursos da geotecnia',
        'Registros de Operação (Histórico)',
        'Registros da Manutenção (Histórico)',
        'Registro de Manutenção',
        'Fichas de Inspeções de Segurança de Barragens (histórico)',
        'Registro de Treinamento (Histórico)',
        'Registros dos testes de equipamentos hidráulicos, elétricos e mecânicos',
        'Orçamento CAPEX',
        'Orçamento OPEX',
        'Matriz de riscos',
        'Relatórios de inspeção bimestral e de desempenho',
        'Relatório mensal de performance geotécnica',
        'Balanço hídrico',
        'Balanço de massa',
        'Batemetrias',
        'DCE',
        'Manifestação de Ciência',
        'Treinamento e Divulgação',
        'Registro Treinamento PAEBM',
        'Protocolos Entrega PAEBM',
        'PAEBM anteriores',
        'Relatório de Inspeção de Segurança de Rotina'
    ]
};

export const combinedFileTypes: string[] = [
    ...FilesType.informacoes_gerais,
    ...FilesType.documentacao_tecnica_do_empreendimento,
    ...FilesType.plano_de_acao_de_emergencia_pae,
    ...FilesType.planos_e_procedimentos,
    ...FilesType.registros_e_controles,
];

export const instrumentsTypes = [
    'vazao',
    'piezometro',
    'regua',
    'marco',
    'base',
    're',
    'inclinometro',
    'pluviometro',
    'indicador',
];
